/* @flow */
import React from 'react'
import { SuccessIcon } from '@/assets/icons'
import { questionDetailUrl, keepQueryString } from '@/urls'

import { i18n } from '@/locale/i18n'
import { Link } from 'react-router-dom'
import { useCurrentRouteName } from '@/hooks'

const WagerSell = props => {
  const currentPage = useCurrentRouteName()
  const isMarketPage = currentPage === 'Market page'
  const { question } = props

  return (
    <a href={keepQueryString(questionDetailUrl(question))}>
      <div className=" font-bold flex items-center gap-4">
        <SuccessIcon />

        <div className="flex items-center gap-1">
          <div>{i18n('place_bet.sold')}</div>
          {!isMarketPage && (
            <div className="link underline  !font-bold  ">
              <Link to={keepQueryString(questionDetailUrl(question))}>{i18n('place_bet.view_market_details')}</Link>
            </div>
          )}
        </div>
      </div>
    </a>
  )
}

export default WagerSell
